import Vue from "vue";
import axios from 'axios';
import { Toast } from 'mint-ui';

var BASEURL1;
var BASEURL2;
if(location.hostname==='localhost'){  //local
  BASEURL1="http://dev.kidsrkidschina.com"; 
  BASEURL2 = "http://dev.kidsrkidschina.com";
  Vue.prototype.$uploadUrl = "http://dev.kidsrkidschina.com";
}else if(location.hostname==='47.93.230.5'||location.hostname==='dev.kidsrkidschina.com'){  //dev
  BASEURL1="http://dev.kidsrkidschina.com";
  BASEURL2 = "http://dev.kidsrkidschina.com";
  Vue.prototype.$uploadUrl = "http://dev.kidsrkidschina.com";
}else if(location.hostname==='47.94.143.244'||location.hostname==='test.kidsrkidschina.com'){  //test
  BASEURL1="https://test.kidsrkidschina.com"; 
  BASEURL2 = "https://test.kidsrkidschina.com";
  Vue.prototype.$uploadUrl = "https://test.kidsrkidschina.com";
}else if(location.hostname==='api.kidsrkidschina.com'){  //prd
  BASEURL1= 'https://api.kidsrkidschina.com';
  BASEURL2 =  'https://api.kidsrkidschina.com';
  Vue.prototype.$uploadUrl =  'https://api.kidsrkidschina.com';
}else{
  Toast({
    message: '系统异常，请联系管理员'          
  });
  retrurn ;
}


const loadTime = 800;
// 添加请求拦截器
axios.defaults.timeout = 20 * 1000


axios.interceptors.request.use(config => {

  return config;
}, function (error) {
  console.log('AJAX_Error', error);

  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  return Promise.reject(error);
});

export function Get(url, params, port) {
  const self = this;
  if (port === "9000") {
    url = BASEURL2 + url
  } else {
    url = BASEURL1 + url
  }
  let state = false;
  setTimeout(() => {
    if (state) {
      return false;
    }
  }, loadTime);

  return new Promise((resolve, reject) => {

    axios.get(url, {
        params,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        state = true;
        if (res.data.code == "00") {
          resolve(res.data)
        } else {
          Toast({
            message: res.data.msg          
          });
          reject(res.data)

        }
      })
      .catch(err => {
        state = true;
        Toast({
          message: '请求失败，请稍后再试'          
        });
        reject(err.data)
      })
  })
}

export function Post(url, params, port) {
  const self = this;
  if (port === "9000") {
    url = BASEURL2 + url
  } else {
    url = BASEURL1 + url
  }
  let state = false;
  setTimeout(() => {
    if (state) {
      return false;
    }
  }, loadTime);
  return new Promise((resolve, reject) => {
    axios.post(url, JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        state = true;
        if (res.data.code == "00") {
          resolve(res.data)
        } else {
          Toast({
            message: res.data.msg         
          });
          reject(res.data)
        }
      })
      .catch(err => {
        state = true;
        Toast({
          message: '请求失败，请稍后再试'          
        });
        reject(err.data)
      })
  })
}




export default {
  Get,
  Post
};



// WEBPACK FOOTER //
// ./src/api/request.js